import React from 'react';
import {
  Alert,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {
  getQrContrastRatio,
  QR_CORNER_DOT_STYLE_OPTIONS,
  QR_CORNER_SQUARE_STYLE_OPTIONS,
  QR_DOT_STYLE_OPTIONS,
  QR_PRESET_OPTIONS,
} from '../../utils/qrStyleOptions';

const QrStyleControls = ({
  preset,
  dotStyle,
  cornerSquareStyle,
  cornerDotStyle,
  onPresetChange,
  onDotStyleChange,
  onCornerSquareStyleChange,
  onCornerDotStyleChange,
  showContrastWarning = false,
  foregroundColor,
  backgroundColor,
  disabled = false,
}) => {
  const contrastRatio = getQrContrastRatio(foregroundColor, backgroundColor).toFixed(2);

  return (
    <Stack spacing={1.5} mt={1} mb={2}>
      <Typography variant="subtitle2">QR Style</Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            select
            fullWidth
            label="Preset"
            value={preset}
            onChange={(event) => onPresetChange(event.target.value)}
            disabled={disabled}
          >
            {QR_PRESET_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
            <MenuItem value="custom">Custom</MenuItem>
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            select
            fullWidth
            label="Dot Style"
            value={dotStyle}
            onChange={(event) => onDotStyleChange(event.target.value)}
            disabled={disabled}
          >
            {QR_DOT_STYLE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            select
            fullWidth
            label="Corner Square Style"
            value={cornerSquareStyle}
            onChange={(event) => onCornerSquareStyleChange(event.target.value)}
            disabled={disabled}
          >
            {QR_CORNER_SQUARE_STYLE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            select
            fullWidth
            label="Corner Dot Style"
            value={cornerDotStyle}
            onChange={(event) => onCornerDotStyleChange(event.target.value)}
            disabled={disabled}
          >
            {QR_CORNER_DOT_STYLE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      {showContrastWarning ? (
        <Alert severity="warning" variant="outlined">
          Foreground and background contrast is low for scanning reliability. Current ratio: {contrastRatio}:1.
          The High Contrast Print preset is the safest option for print and signage.
        </Alert>
      ) : null}
    </Stack>
  );
};

export default QrStyleControls;
